<template>
  <div class="step-container">
    <div class="content">
      <keep-alive>
        <component
          :is="com"
          ref="com"
          @next="next"
          @pre="pre"
          :title="title"
          :codeId="codeId"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  props: ["comArr", "title", "myactiveStep"],

  data() {
    return {
      codeId: "",
    };
  },

  mounted() {
    const query = this.$route.query;

    this.activeStep = parseInt(query.step) || 0;
  },

  computed: {
    com() {
      if (!this.comArr.length) return;
      console.log("this.activeStep", this.activeStep);
      const path = this.comArr[this.activeStep];
      // let myComponent = () => import(`${path}`);
      const myComponent = (resolve) => require([`@/views/${path}`], resolve);
      return myComponent;
    },
    activeStep: {
      get() {
        return this.myactiveStep;
      },
      set(val) {
        this.$emit("active", val);
        // console.log("set:", val);
      },
    },
  },

  methods: {
    next(id) {
      console.log("next:", id);
      this.activeStep++;
      this.codeId = id;
    },
    pre() {
      this.activeStep--;
    },
    returnBasic(index) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          flag: this.$route.query.flag,
          codeId: this.codeId,
          step: index,
          edit: "update",
        },
      });
    },
  },

  watch: {
    $route(newValue) {
      // alert(newValue)
      // this.activeStep = parseInt(newValue.query.step);
    },
  },
};
</script>

<style scoped lang="scss">
.step-container {
  flex: 1;
  overflow: auto;
  box-shadow: 0px 4px 12px 0px #cccccc80;
  border-radius: 4px;
  background-color: white;
  padding: 20px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  margin-top: 20px ;
}

.el-input__inner {
  border: 0;
}

.content {
  height: 100%;
}
</style>
